import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { Time32, True32, Txt32 } from '../../../../../public/LoginImages/importimages'
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext'
const ECSResponseFiles = () => {
   const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext)
  const { getecsreponsefiles, getecsresponse } = context
  const [getResponse, setResponse] = useState([])
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = getResponse.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(getResponse.length / rowsPerPage);

  useEffect(() => {
    GetECSResponse()
  }, [])
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    let data = await getecsreponsefiles()
    console.log(data);
    alert(data.message)
    if (data.message) {
      setLoading(false);
      GetECSResponse()
    }
  }
  const GetECSResponse = async () => {
    let data = await getecsresponse()
    console.log(data);
    setResponse(data)
  }

  // return (
  //   <div style={{ display: 'grid', justifyContent: 'center', padding: "55px 20px", overflow: "auto", backgroundColor: '#f4f7fe', maxHeight: '94vh' }}>
  //     <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 10px", borderRadius: "20px", width: "75vw", maxWidth: "100%", }}>
  //       {getResponse.length < 1 ? <> <div style={{ fontSize: '25px', padding: '20px', color: 'black', textAlign: 'center', backgroundColor: '#f4f7fe' }}>No Response Files</div></> : getResponse.length > 0 && (
  //         <>
  //           <div style={{ overflowX: "auto", width: "100%", borderRadius: "20px", }}>
  //             <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", minWidth: "78vw", }}>
  //               <thead style={{ borderTop: "none" }}>
  //                 <tr style={{ background: 'linear-gradient(to bottom, #B7D7EA , #B2D1E6 , #C4C5E2 )', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", textAlign: "center", }}>
  //                   <th>Sr.No</th>
  //                   <th>File Name</th>
  //                   <th>Unique ID</th>
  //                   <th>CMS Ref No	</th>
  //                   <th>Account Number</th>
  //                   <th>Amount</th>
  //                   <th>Account Holder Name</th>
  //                   <th>Status</th>
  //                   <th>Payment Date</th>
  //                   <th>Response Date</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {currentRows.map((x, index) => {
  //                   return (
  //                     <tr key={index}>
  //                       <td>{indexOfFirstRow + index + 1}</td>
  //                       <td style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img  style={{ width: '15px' }} /> {x.File_Name}</td>
  //                       <td>{x.Unique_ID}</td>
  //                       <td>{x.cmsRef}</td>
  //                       <td>{x.AccNumber}</td>
  //                       <td>{x.refund_amount}</td>
  //                       <td>{x.Account_HolderName}</td>
  //                       <td style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img  style={{ width: '15px' }} /> {x.status}</td>
  //                       <td><div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img style={{ width: '15px' }} /> {x.Payment_Date}</div></td>
  //                       <td><img  style={{ width: '15px' }} />{new Date(x.Date).toLocaleString('en-GB', {
  //                         year: 'numeric',
  //                         month: '2-digit',
  //                         day: '2-digit',
  //                         hour: '2-digit',
  //                         minute: '2-digit',
  //                         second: '2-digit',
  //                         hour12: false
  //                       }).replace(',', '')}</td>
  //                     </tr>
  //                   );
  //                 })}
  //               </tbody>
  //             </table>
  //           </div>
  //         </>
  //       )}

  //     </div>
  //     <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
  //       <div><button className='btn btn-primary' style={{ background: 'linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5)', margin: '10px', alignItems: 'center', fontWeight: '600' }} disabled={loading} cursor={loading ? "not-allowed" : "pointer"} onClick={handleSubmit}>{loading ? "Getting Response Files.." : "Get Response Files"}</button></div>
  //       <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
  //         <div style={{ display: 'flex', alignItems: 'center' }}>
  //           {/* First Page Button */}
  //           <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
  //             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
  //             &laquo;
  //           </button>
  //           {/* Previous Button */}
  //           <button
  //             onClick={() => setCurrentPage(currentPage - 1)}
  //             disabled={currentPage === 1}
  //             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
  //             &lt;
  //           </button>

  //           <button
  //             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
  //           </button>
  //           {/* Next Button */}
  //           <button
  //             onClick={() => setCurrentPage(currentPage + 1)}
  //             disabled={currentPage === totalPages}
  //             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
  //             &gt;
  //           </button>
  //           {/* Last Page Button */}
  //           <button
  //             onClick={() => setCurrentPage(totalPages)}
  //             disabled={currentPage === totalPages}
  //             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
  //             &raquo;
  //           </button>
  //         </div>

  //       </div>
  //     </div>
  //   </div>
  // )
  return (
    <div style={{ display: 'grid', justifyContent: 'center', padding: "55px 20px", overflow: "auto", backgroundColor: '#f4f7fe', maxHeight: '94vh' }}>
      <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 10px", borderRadius: "20px", width: "75vw", maxWidth: "100%", }}>
        {getResponse.length < 1 ? <> <div style={{ fontSize: '25px', padding: '20px', color: 'black', textAlign: 'center', backgroundColor: '#f4f7fe' }}>{t('No Response Files')}</div></> : getResponse.length > 0 && (
          <>
            <div style={{ overflowX: "auto", width: "100%", borderRadius: "20px", }}>
              <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", minWidth: "78vw", }}>
                <thead style={{ borderTop: "none" }}>
                  <tr style={{ background: 'linear-gradient(to bottom, #B7D7EA , #B2D1E6 , #C4C5E2 )', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", textAlign: "center", }}>
                    <th>{t('Sr.No')}</th>
                    <th>{t('File Name')}</th>
                    <th>{t('Unique ID')}</th>
                    <th>{t('CMS Ref No')}</th>
                    <th>{t('Account Number')}</th>
                    <th>{t('Amount')}</th>
                    <th>{t('Account Holder Name')}</th>
                    <th>{t('Status')}</th>
                    <th>{t('Payment Date')}</th>
                    <th>{t('Response Date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((x, index) => {
                    return (
                      <tr key={index}>
                        <td>{indexOfFirstRow + index + 1}</td>
                        <td style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img  style={{ width: '15px' }} /> {x.File_Name}</td>
                        <td>{x.Unique_ID}</td>
                        <td>{x.cmsRef}</td>
                        <td>{x.AccNumber}</td>
                        <td>{x.refund_amount}</td>
                        <td>{x.Account_HolderName}</td>
                        <td style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img  style={{ width: '15px' }} /> {x.status}</td>
                        <td><div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-start', height: '2rem', border: 'none' }}><img style={{ width: '15px' }} /> {x.Payment_Date}</div></td>
                        <td><img  style={{ width: '15px' }} />{new Date(x.Date).toLocaleString('en-GB', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).replace(',', '')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}

      </div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div><button className='btn btn-primary' style={{ background: 'linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5)', margin: '10px', alignItems: 'center', fontWeight: '600' }} disabled={loading} cursor={loading ? "not-allowed" : "pointer"} onClick={handleSubmit}>{loading ? "Getting Response Files.." : "Get Response Files"}</button></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* First Page Button */}
            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
              &laquo;
            </button>
            {/* Previous Button */}
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &lt;
            </button>

            <button
              style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
            </button>
            {/* Next Button */}
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &gt;
            </button>
            {/* Last Page Button */}
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &raquo;
            </button>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ECSResponseFiles